import { render } from "./RouterView.vue?vue&type=template&id=015617d0"
import script from "./RouterView.vue?vue&type=script&lang=js"
export * from "./RouterView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__